module.exports = {
	"textures": [
		{
			"image": "Ball_Dropped_Zoom.png",
			"format": "RGBA8888",
			"size": {
				"w": 1188,
				"h": 1188
			},
			"scale": 1,
			"frames": [
				{
					"filename": "0.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "1.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 1,
						"y": 133,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "10.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 1,
						"y": 265,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "11.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 1,
						"y": 397,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "12.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 1,
						"y": 529,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "13.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 1,
						"y": 661,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "14.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 1,
						"y": 793,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "15.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 1,
						"y": 925,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "16.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 1,
						"y": 1057,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "17.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 127,
						"y": 1,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "18.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 253,
						"y": 1,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "19.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 379,
						"y": 1,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "2.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 505,
						"y": 1,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "20.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 631,
						"y": 1,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "21.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 757,
						"y": 1,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "22.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 883,
						"y": 1,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "23.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 1009,
						"y": 1,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "24.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 127,
						"y": 133,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "25.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 127,
						"y": 265,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "26.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 127,
						"y": 397,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "27.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 127,
						"y": 529,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "28.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 127,
						"y": 661,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "29.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 127,
						"y": 793,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "3.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 127,
						"y": 925,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "30.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 127,
						"y": 1057,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "31.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 253,
						"y": 133,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "32.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 379,
						"y": 133,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "33.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 505,
						"y": 133,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "34.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 631,
						"y": 133,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "35.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 757,
						"y": 133,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "36.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 883,
						"y": 133,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "4.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 1009,
						"y": 133,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "5.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 253,
						"y": 265,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "6.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 253,
						"y": 397,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "7.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 253,
						"y": 529,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "8.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 253,
						"y": 661,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "9.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 253,
						"y": 793,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_0.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 253,
						"y": 925,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_1.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 253,
						"y": 1057,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_10.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 379,
						"y": 265,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_11.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 505,
						"y": 265,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_12.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 631,
						"y": 265,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_13.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 757,
						"y": 265,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_14.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 883,
						"y": 265,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_15.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 1009,
						"y": 265,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_16.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 379,
						"y": 397,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_17.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 379,
						"y": 529,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_18.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 379,
						"y": 661,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_19.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 379,
						"y": 793,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_2.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 379,
						"y": 925,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_20.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 379,
						"y": 1057,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_21.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 505,
						"y": 397,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_22.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 631,
						"y": 397,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_23.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 757,
						"y": 397,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_24.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 883,
						"y": 397,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_25.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 1009,
						"y": 397,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_26.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 505,
						"y": 529,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_27.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 505,
						"y": 661,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_28.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 505,
						"y": 793,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_29.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 505,
						"y": 925,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_3.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 505,
						"y": 1057,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_30.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 631,
						"y": 529,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_31.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 757,
						"y": 529,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_32.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 883,
						"y": 529,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_33.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 1009,
						"y": 529,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_34.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 631,
						"y": 661,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_35.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 631,
						"y": 793,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_36.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 631,
						"y": 925,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_37.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 631,
						"y": 1057,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_4.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 757,
						"y": 661,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_5.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 883,
						"y": 661,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_6.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 1009,
						"y": 661,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_7.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 757,
						"y": 793,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_8.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 757,
						"y": 925,
						"w": 124,
						"h": 130
					}
				},
				{
					"filename": "double_zero_9.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 130
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 130
					},
					"frame": {
						"x": 757,
						"y": 1057,
						"w": 124,
						"h": 130
					}
				}
			]
		}
	],
	"meta": {
		"app": "https://www.codeandweb.com/texturepacker",
		"version": "3.0",
		"smartupdate": "$TexturePacker:SmartUpdate:21caf334dd5125b428577588ca41f49c:cf92a8c58cd6dd009743ccebf25b34e3:26d63e31993f153d55bede325595f0c7$"
	}
}
;